export default __webpack_public_path__ + "static/media/2.56217859.png";